'use client'

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ActionTypes, useAppDispatch, useAppState } from '../../Store'

export const useModal = () => {

    const [open, setOpen] = useState(false);

    return { open, setOpen }
}

export default function Modal({ open, onClose, title, description, children, maxWidth = 'sm:max-w-sm' }) {

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[100]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-[100] w-screen overflow-y-auto">
        <div className="flex min-h-screen items-center justify-center p-4 text-center">
          <DialogPanel
            transition
            className={`relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 ${maxWidth}`}
          >
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">{title}</h2>
                <button onClick={onClose} className="text-2xl font-bold hover:opacity-70">
                  <XMarkIcon className="size-6 text-gray-500" />
                </button>
              </div>
              <p className="text-sm text-gray-500 -mt-2">{description}</p>
            </div>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
